<template>
  <Loading :active="isLoading"></Loading>
  <div class="container">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link to="/user/cart">購物車</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          {{ product.title }}
        </li>
      </ol>
    </nav>
    <div class="row justify-content-center">
      <article class="col-8">
        <h2>{{ product.title }}</h2>
        <div>{{ product.content }}</div>
        <div>{{ product.description }}</div>
        <img :src="product.imageUrl" alt="" class="img-fluid mb-3" />
      </article>
      <div class="col-4">
        <div class="h5" v-if="!product.price">
          {{ product.origin_price }} 元
        </div>
        <del class="h6" v-if="product.price"
          >原價 {{ product.origin_price }} 元</del
        >
        <div class="h5" v-if="product.price">
          現在只要 {{ product.price }} 元
        </div>
        <select v-model.number="productqty">
          <option value="" disabled>數量</option>
          <option :value="qty" v-for="qty in 10" :key="qty">{{ qty }}</option>
        </select>
        <hr />
        <button
          type="button"
          class="btn btn-outline-danger"
          :disabled="this.status.loadingItem == product.id"
          @click="addToCart(product.id)"
        >
          <div
            class="spinner-border spinner-border-sm text-danger"
            role="status"
            v-if="this.status.loadingItem == product.id"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
          加到購物車
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      product: {},
      id: "",
      isLoading: false,
      productqty: "",
      status: {
        loadingItem: "",
      },
    };
  },
  methods: {
    getProduct() {
      const api = `${process.env.VUE_APP_API}/api/${process.env.VUE_APP_PATH}/product/${this.id}`;
      this.isLoading = true;
      this.$http.get(api).then((res) => {
        this.isLoading = false;
        // console.log(res.data);
        this.product = res.data.product;
      });
    },
    addToCart(id) {
      const api = `${process.env.VUE_APP_API}/api/${process.env.VUE_APP_PATH}/cart`;
      const cart = {
        product_id: id,
        qty: this.productqty,
      };
      this.status.loadingItem = id;
      this.$http.post(api, { data: cart }).then((res) => {
        this.status.loadingItem = "";
        console.log(res.data);
      });
    },
  },
  created() {
    // console.log(this.$route);
    this.id = this.$route.params.productId;
    this.getProduct();
  },
};
</script>
